'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '../../common/Button';
import Modal, { ModalContent, ModalFooter, ModalHeader } from '../../HOC/Modal';
import { useNewPostContext } from './NewPostContext';
export const SaveDraftConfModal = () => {
  const $ = _c(13);
  const {
    saveDraftConfModalOpen,
    closeHandler,
    saveDraft,
    buttonLoading
  } = useNewPostContext();
  if (!saveDraftConfModalOpen) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ModalHeader><h2>Save Post</h2></ModalHeader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ModalContent><p className="text-start text-textPrimary">Do you want to save this post in your drafts? You can publish it any time later.</p></ModalContent>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== closeHandler) {
    t2 = <Button text="Discard" onClick={() => closeHandler(false)} variant="SECONDARY" borderTransparent={false} classNames="w-28" />;
    $[2] = closeHandler;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== buttonLoading || $[5] !== saveDraft) {
    t3 = <Button text="Save" onClick={saveDraft} loading={buttonLoading} disabled={buttonLoading} classNames="w-28" />;
    $[4] = buttonLoading;
    $[5] = saveDraft;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <ModalFooter>{t2}{t3}</ModalFooter>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== closeHandler || $[11] !== t4) {
    t5 = <Modal closeHandler={closeHandler}>{t0}{t1}{t4}</Modal>;
    $[10] = closeHandler;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};